<template>
  <!-- Section board -->
  <v-container pa-0 ma-0 fluid>
    <div :class="`show-hot-job-${isSearchFixed}`" v-if="isHotJobs"></div>
    <div class="banner-wrap">
      <Banner
        :is-hitech="searchProperties ? searchProperties.IsHitechPage : false"
        :isLoading="isLoading"
        v-show="!isLoading"
      />
    </div>
    <v-responsive
      id="jobs-board"
      class="primary--text norm"
      relaive
      ref="jobsBoard"
    >
      <v-layout
        align-center
        text-center
        pa-0
        class="jobs-board-content"
        ref="jobsBoard"
        :class="isStickyFilter ? '' : 'isStickyFilter'"
      >
        <v-flex
          id="jobs-page-search"
          :class="isStickyFilter ? '' : 'isStickyFilter'"
        >
          <Sticky
            :is-no-cv-page="isNoCvPage"
            ref="sticky"
            :is-sticky="isStickyFilter"
            :class="'norm'"
            :filters="filters"
            :search-properties="searchProperties"
            :is-loading="isLoading"
          />
        </v-flex>
      </v-layout>
    </v-responsive>
  </v-container>
</template>

<script>
import Banner from '@/components/Jobs_List/Banner';
import Sticky from '@/components/Jobs_List/Sticky_Search/Sticky1';

export default {
  components: {
    Sticky,
    Banner,
  },

  props: {
    isNoCvPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHotJobs: {
      type: Boolean,
      required: false,
      default: false,
    },
    filters: {
      type: Object,
      required: false,
      default: () => {},
    },
    searchProperties: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      scrollPosition: null,
      offset: 250,
      initialOffsetTop: null,
    };
  },

  computed: {
    catNumBanner() {
      return this.searchProperties ? this.searchProperties.IsHitechPage : -1;
    },

    // String for applyed class
    isSearchFixed() {
      return !this.scrollPosition ? 'norm' : 'sticky';
    },
    // Boolean for children components props
    isStickyFilter() {
      if (this.scrollPosition >= this.initialOffsetTop) {
        return false;
      } else {
        return true;
      }
      // return this.scrollPosition <= this.offset;
    },
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.pageYOffset;
    },
  },

  mounted() {
    const searchTitle = document.querySelector('.search-title');
    if (searchTitle) {
      this.initialOffsetTop = searchTitle.offsetTop;
      window.addEventListener('scroll', this.updateScroll);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll);
  },
};
</script>

<style lang="scss" scoped>
// trying to use the css from html file
#jobs-board.isStickyFilter {
  position: fixed;
  width: 100%;
  top: 0;
}
.jobs-board-content.isStickyFilter {
  position: fixed;
  width: 100%;
  top: 0;
  background-color: #e8e9eb;
  animation: topToBottom ease 1s;
}
@keyframes topToBottom {
  0% {
    margin-top: -23%;
  }
  100% {
    margin-top: 0%;
  }
}
.sticky {
  content: '';
  position: fixed;
  background-color: #e7e8ea;
  top: 0;
  z-index: 0;
  box-shadow: 0 0 10px rgba(46, 46, 46, 0.3);
}

.norm {
  box-shadow: 0 0 10px rgba(34, 49, 26, 0.01);
  display: flex;
  flex-direction: column;
}

.v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  width: none;
}

#jobs-board {
  background-color: #e8e9eb;
  min-height: 280px;
  background-size: cover;
  position: relative;
  overflow: unset;
  z-index: 1;
}

.display-2 {
  font-size: 24px !important;
  line-height: 0.92 !important;
  letter-spacing: -1.5px !important;
  margin-top: 15px;
}

.v-text-field > .v-input__control > .v-input__slot:after {
  width: 0px;
}

#home-search .v-input__slot:before {
  border: none;
}

#home-search input {
  color: $primary;
  font-size: 24px;
}

#home-search ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: $primary;
  opacity: 1;
  /* Firefox */
}

#home-search .theme--light.v-icon {
  color: $primary;
}

#jobs-board.sticky {
  background: transparent;
  box-shadow: none;
}

.show-hot-job-norm {
  padding-top: 0;
}

@media only screen and (min-width: 600px) {
  #jobs-board {
    background-color: #e8e9eb;
    background-size: cover;
  }
}

@media only screen and (min-width: 1260px) {
  #jobs-board.norm {
    background-size: cover;
    height: 160px;
    padding: 25px 0;
    min-height: auto;
  }
}
</style>
